import { AnalyticsBrowser } from '@segment/analytics-next';

const segmentApiKey = import.meta.env.VITE_SEGMENT_KEY;

export const segment = AnalyticsBrowser.load({ writeKey: segmentApiKey });
